import register from '@kpsys/angularjs-register';
import attributionsRoutes from './attributions.routes';

export default register('portaro.features.attributions')
    .config(attributionsRoutes)
    .name();